module.exports = __webpack_public_path__ + "img/tribeid.64d9d748.png";